import { Flex } from "@/atoms"
import { useOrderBy } from "@/hooks/useOrderBy"
import { useQueryString } from "@/hooks/useQueryString"
import { useTooltip } from "@/hooks/useTooltip"
import { useTranslation } from "@/hooks/useTranslation"
import { LoadErrorEmptyTable } from "@/molecules/EmptyTable"
import { TokenPagination } from "@/molecules/TokenPagination"
import { AGENT_AI_DISCOVERY_DRAWER_ID } from "@/organisms/Drawers/const"
import { useDrawer } from "@/organisms/Drawers/hooks/useDrawer"
import { useAiPolicyDecisions } from "@/pages/GovernancePage/applications/ai-policies/useLiveAiPolicies"
import { TabTemplate } from "@/templates/TabTemplate"
import { DECISIONS_FILTER_KEYS } from "../../const"
import { FilterDecisionsTab } from "../FilterDecisionsTab"
import { getColumnsTable } from "./getColumnsTable"

import styles from "./DecisionsTab.module.scss"

// Every tool call that violated a real policy, newest first, in the policies
// list's layout
export const DecisionsTab = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "governance.ai.live.decisions"
  })
  const { t: tRoot } = useTranslation()
  const {
    policy,
    policyKind,
    platform,
    agentId,
    tool,
    outcome,
    enforcedBy,
    orderBy,
    ascending
  } = useQueryString([...DECISIONS_FILTER_KEYS, "orderBy", "ascending"])
  const { onSorterChange, ...sorter } = useOrderBy()
  const decisions = useAiPolicyDecisions({
    policyId: policy,
    policyKind,
    platform,
    agentId,
    tool,
    outcome,
    enforcedBy,
    orderBy,
    ascending
  })
  const { onRowClick } = useDrawer(AGENT_AI_DISCOVERY_DRAWER_ID)
  const getEmptyText = () => {
    // Nothing is empty until the decisions have loaded
    if (decisions.isLoading) return null
    if (decisions.isError)
      return <LoadErrorEmptyTable onRetry={decisions.refetch} />

    return t(decisions.isServed ? "empty" : "notServed")
  }

  useTooltip(decisions.rows)

  return (
    <Flex vertical gap={16} className={styles.container}>
      <FilterDecisionsTab
        policies={decisions.policies}
        arePoliciesLoading={decisions.arePoliciesLoading}
      />
      <TabTemplate
        sticky
        resizable
        loading={decisions.isLoading}
        dataSource={decisions.rows}
        columns={getColumnsTable(tRoot, onRowClick, sorter)}
        onChange={(_pagination, _filters, sorted) => onSorterChange(sorted)}
        locale={{ emptyText: getEmptyText() }}
        asideFooter={<TokenPagination {...decisions} />}
      />
    </Flex>
  )
}
